import { Route } from "react-router-dom"
import { pagesUrl } from "@app/core/appConstants"
import { withoutAppSideBar } from "@app/core/context/AppSideBarContext/AppSideBarContext"

/**
 * US 2886 — Quanti routes.
 *
 * Spread into ApplicationRoutes beside RseeRoutes and BSRoutes, so the module inherits the authenticated
 * layout, the project contexts and the side bar without restating them. Its own providers and its page are
 * loaded lazily, in QuantiRouteLayout, like every module on main.
 */
export const QuantiRoutes = (
  // A variant's screens take the whole screen: no side bar.
  <Route
    handle={withoutAppSideBar}
    lazy={() => import("./QuantiRouteLayout").then((module) => ({ Component: module.QuantiRouteLayout }))}>
    <Route
      path={pagesUrl.QUANTI_VARIANT_DETAILS}
      lazy={() =>
        import("@app/pages/projects/project/quanti/QuantiVariantDetailsPage").then((module) => ({
          Component: module.QuantiVariantDetailsPage,
        }))
      }
    />
  </Route>
)
